import { Card, CardContent, CardHeader, Grid, Skeleton, Typography } from "@mui/material";

interface AssignedEquipmentInspection {
    userEquipments: any;
    isLoading: boolean;
}
export const AssignedEquipmentInspection = ({ userEquipments, isLoading }: AssignedEquipmentInspection) => {
    return (
        <Card elevation={0} className="">
            <CardHeader
                className="subHead"
                title={
                    <Typography variant="h3" color="textPrimary">
                        Assigned Equipment
                    </Typography>
                }
            ></CardHeader>
            <CardContent className="formContainer">
                <Grid container spacing={1}>
                    {!isLoading ?
                        userEquipments?.map((equipment: any) => (
                            <Grid key={equipment?.equipmentID} item xs={12}>
                                <Typography>{equipment?.equipmentName}</Typography>
                            </Grid>
                        ))
                        :
                        <>
                            <Grid item lg={12} sm={12} xl={12} xs={12} display={'flex'} flexDirection={'column'}>
                                <Skeleton variant="rectangular" width={340} height={20} />
                            </Grid>
                            <Grid item lg={12} sm={12} xl={12} xs={12} display={'flex'} flexDirection={'column'}>
                                <Skeleton variant="rectangular" width={340} height={20} />
                            </Grid>
                        </>
                }
                </Grid>
            </CardContent>
        </Card>
    );
}